/*
 * argile-presse.js — Page « Argile dans la presse ».
 *
 * Deux choses seulement : trier les cartes par `rang`, et dévoiler par paquets au clic
 * sur « voir plus ». Tout est déjà rendu dans le DOM par Liquid — un métaobjet n'est pas
 * une collection paginable, il n'y a rien à demander au serveur. Même parti pris que
 * argile-projets.js, dont ceci est la version dégraissée (ni facettes, ni tri au choix,
 * ni compteur).
 *
 * ⚠️ Le tri se fait ICI et pas en Liquid : l'ordre de `shop.metaobjects.<type>.values`
 * n'est pas garanti, et `sort` sur une propriété de drop métaobjet est un pari.
 *
 * Sans JS, les `page_size` premières cartes restent visibles et le bouton ne fait rien.
 * La page reste lisible — c'est la dégradation acceptée.
 */
(() => {
  const init = (racine) => {
    const portee = racine.querySelector('[data-presse]');
    const grille = racine.querySelector('[data-presse-grid]');
    if (!portee || !grille || portee.dataset.initialise === '1') return;
    portee.dataset.initialise = '1';

    const pageSize = Math.max(1, parseInt(portee.dataset.pageSize, 10) || 9);
    const items = Array.from(grille.querySelectorAll('[data-presse-item]'));
    const loadMore = racine.querySelector('[data-presse-loadmore]');
    const boutonPlus = racine.querySelector('[data-presse-more]');

    let limite = pageSize;

    const rang = (el) => {
      const n = parseInt(el.dataset.rang, 10);
      return Number.isNaN(n) ? 9999 : n;
    };

    // Réordonner le DOM plutôt que jouer sur `order` en CSS : l'ordre du DOM est aussi
    // celui de la tabulation et celui qu'annonce un lecteur d'écran.
    const ordonnes = [...items].sort((a, b) => rang(a) - rang(b));
    ordonnes.forEach((el) => grille.appendChild(el));

    const rendre = () => {
      ordonnes.forEach((el, i) => el.classList.toggle('is-hidden', i >= limite));
      if (loadMore) loadMore.hidden = ordonnes.length <= limite;
    };

    boutonPlus?.addEventListener('click', () => {
      limite += pageSize;
      rendre();
    });

    rendre();
  };

  const initTout = (portee = document) => portee.querySelectorAll('.argile-presse').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTout());
  } else {
    initTout();
  }

  document.addEventListener('shopify:section:load', (e) => initTout(e.target));
})();
